export default __webpack_public_path__ + "static/logo_primary-bcb80c7f58be0daa16e8cf39f60b468e.svg";